import { CourseResourceApi } from "api";
import { ModalHeader } from "../../../components/templates/Modals/ModalHeader";
import { ModalPadding } from "../../../components/templates/Modals/ModalPadding";
import { PaziaModal } from "components/molecules";

interface ChangeResourceTabModalProps {
  onCloseRequest: () => void;
  courseId: number;
  resource: CourseResourceApi | null;
}

export const ChangeResourceTabModal = ({ courseId, onCloseRequest, resource }: ChangeResourceTabModalProps) => {
  return (
    <PaziaModal
      id="add-resource-modal"
      onCloseRequest={() => {
        onCloseRequest();
      }}
      isOpen={resource !== null}
      size="lg"
    >
      <ModalPadding>
        <ModalHeader>Przenieś do zakładki</ModalHeader>
      </ModalPadding>
    </PaziaModal>
  );
};
